/**
 *
 * @param {number} width
 * @param {number} height
 * @returns {array[number, number]}
 */
const scaleCalc = (width, height) => {
  let scale = 1;

  scale =
    width < 700 && height >= 700
      ? 0.6
      : width >= 700 && height >= 700
      ? 0.4
      : width >= 1900 && height >= 1900
      ? 0.35
      : 1;

  return [width * scale, height * scale];
};

/**
 * @param {number} width
 * @param {number} height
 * @param {boolean} layoutStage
 * @param {boolean} returnNumber
 * @return {string | number}
 */
const returnScaleByWidth = (width, height, returnNumber = false, layoutStage = false) => {
  if (layoutStage && width > 700) {
    return returnNumber ? .1 : "scale(0.1)";
  }

  if (width < 700 && height >= 700) {
    return returnNumber ? .6 : "scale(0.6)";
  } else if (width >= 700 && height >= 700) {
    return returnNumber ? .4 : "scale(0.4)";
  } else if (width >= 1900 && height >= 1900) {
    return returnNumber ? .35 : "scale(0.35)";
  }

  return returnNumber ? 1 : "scale(1)";
};

export { scaleCalc, returnScaleByWidth };
